"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const button_module_scss_1 = __importDefault(require("./button.module.scss"));
const Button = ({ children, className, disabled, kind = '', type, role, href, target = '_self', onClick = () => { }, ...other }) => {
    const buttonClasses = (0, classnames_1.default)({
        [button_module_scss_1.default.btn]: true,
        [button_module_scss_1.default[`btn--${kind}`]]: kind,
        [button_module_scss_1.default.isDisabled]: disabled
    }, className);
    const buttonProps = {
        className: buttonClasses,
        onClick: evt => {
            if (!disabled) {
                onClick(evt);
            }
        }
    };
    const button = ((0, jsx_runtime_1.jsx)("button", { type: type, role: role, ...buttonProps, disabled: disabled, ...other, children: children }));
    const anchor = ((0, jsx_runtime_1.jsx)("a", { ...buttonProps, href: href, target: target, ...other, children: children }));
    const btnElement = href ? anchor : button;
    return (btnElement);
};
Button.propTypes = {
    /** Content that will be rendered as children of the Button component. */
    children: prop_types_1.default.node,
    /** Applies a custom class to the Button component. */
    className: prop_types_1.default.string,
    /** If true, the Button is disabled both visually and functionally. */
    disabled: prop_types_1.default.bool,
    /** Required property to control the presentation of the Button. */
    kind: prop_types_1.default.oneOf([
        '',
        'primary',
        'secondary',
        'tertiary',
        'quaternary'
    ]),
    /** Specifies the type attribute passed to the button element when not using the href property. */
    type: prop_types_1.default.oneOf(['button', 'reset', 'submit']),
    /** Specifies the role attribute passed to the button element when not using the href property. */
    role: prop_types_1.default.string,
    /** If passed, the output of this component will be rendered as a link with the value of this property as the link's destination. */
    href: prop_types_1.default.string,
    /** The target attribute to pass to the anchor element when using the href property. */
    target: prop_types_1.default.oneOf(['_self', '_blank', '_parent', '_top']),
    /** A method that will be run when the user clicks the Button component. */
    onClick: prop_types_1.default.func
};
exports.default = Button;
//# sourceMappingURL=button.js.map